<app-search-univ-result-base
  [searchResults]="searchResultsToDisplay"
  [isPremiumIconShown]="isPremiumIconShown"
  [isBtoC]="isBtoC"
  [buttonAbled$]="initializedBookmark$"
  [bookmarkClickEmitted]="bookmarkClickEmitted"
  [errorUnivId$]="errorUnivId$"
  [selectedExamType]="selectedExamType"
  (goToPaperDetailClick)="goToPaperDetail($event)"
  (goToUnivDetailClick)="goToUnivDetail($event)"
  (addUniversityBookmarkClick)="addUniversityBookmark($event)"
  (deleteUniversityBookmarkClick)="deleteUniversityBookmark($event)"
></app-search-univ-result-base>
